import { LoadingButton } from '@mui/lab';
import { ComponentProps, HTMLAttributeAnchorTarget, ReactNode } from 'react';
import { ConvergeTooltip } from './converge-tooltip';
import './button.scss';
interface IPrimaryButtonProps extends ComponentProps<typeof LoadingButton> {
  label: string;
  variant?: 'outlined' | 'contained' | 'text';
  loading?: boolean;
  tooltip?: ReactNode;
  target?: HTMLAttributeAnchorTarget;
  hasMargin?: boolean;
}

export const ConvergeButton = ({
  label,
  variant = 'contained',
  loading,
  disabled = loading,
  tooltip,
  href,
  hasMargin = false,
  target,
  ...other
}: IPrimaryButtonProps) => {
  const extraProps: Omit<IPrimaryButtonProps, 'label'> = {};

  if (href) {
    extraProps.href = href;
    extraProps.target = target;
  }

  const button = (
    <LoadingButton
      disabled={disabled}
      variant={variant}
      color="primary"
      loading={loading}
      {...extraProps}
      {...other}
      className={` primary-btn ${hasMargin ? 'make-margin' : ''}`}
    >
      {label}
    </LoadingButton>
  );

  return tooltip ? (
    <ConvergeTooltip title={tooltip}>
      <div>{button}</div>
    </ConvergeTooltip>
  ) : (
    button
  );
};
